module.exports = __webpack_public_path__ + "static/img/biasfx2-pedal-view.9b15bbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/biasfx2-pedal-view.jpg
// module id = +umV
// module chunks = 12